import { motion, AnimatePresence } from "framer-motion";
import { AlertCircle } from "lucide-react";

export default function ConfirmationModal({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", isDanger = false }) {
    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    className="bg-white dark:bg-[#1A1A1A] rounded-2xl shadow-xl w-full max-w-md overflow-hidden border border-black/5 dark:border-white/5"
                >
                    <div className="p-6">
                        <div className="flex items-center gap-4 mb-4">
                            <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${isDanger ? "bg-red-100 text-red-600" : "bg-gray-100 text-black"}`}>
                                <AlertCircle size={24} />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-black dark:text-white" style={{ fontFamily: "Playfair Display, serif" }}>
                                    {title}
                                </h3>
                                <p className="text-sm text-black dark:text-white/60 mt-1">
                                    {message}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 dark:bg-zinc-800/50 px-6 py-4 flex items-center justify-end gap-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-xl text-xs font-bold tracking-wider text-black hover:text-black/70 dark:text-white/60 dark:hover:text-white hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
                        >
                            {cancelText.toUpperCase()}
                        </button>
                        <button
                            onClick={onConfirm}
                            className={`px-6 py-2 rounded-xl text-xs font-bold tracking-wider text-white shadow-lg transition-all transform hover:-translate-y-0.5 ${isDanger ? "bg-red-500 hover:bg-red-600 shadow-red-500/20" : "bg-black hover:bg-jazz-brown shadow-black/20"}`}
                        >
                            {confirmText.toUpperCase()}
                        </button>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
}
